import { createSelector } from 'reselect'
import { AppGlobalState, Progress } from '../../types'
import { MailingListEntry } from './types'
import { EntityMetadata } from 'modules/domain/types'

const dict = (state: AppGlobalState) => state.mailingList.items
const ids = (state: AppGlobalState) => state.mailingList.ids
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const item = (state: AppGlobalState, id: string): MailingListEntry | undefined => state.mailingList.items[id]
const meta = (state: AppGlobalState, id: string): EntityMetadata<MailingListEntry> =>
  state.mailingList.meta[id] || {
    fetchError: null,
    fetchProgress: Progress.IDLE,
    id,
    removeError: null,
    removeProgress: Progress.IDLE,
    updateError: null,
    updateProgress: Progress.IDLE,
  }
const itemFetchProgress = (state: AppGlobalState) => state.mailingList.itemFetchProgress
const listFetchProgress = (state: AppGlobalState) => state.mailingList.listFetchProgress
const listFetchError = (state: AppGlobalState) => state.mailingList.listFetchError
const listFetchNextProgress = (state: AppGlobalState) => state.mailingList.listFetchNextProgress
const listFetchNextError = (state: AppGlobalState) => state.mailingList.listFetchNextError
const list = createSelector(dict, ids, listFetchProgress, (dict, ids, progress) => {
  if (progress === Progress.WORK) {
    return []
  }
  const result: MailingListEntry[] = []
  for (const id of ids) {
    result.push(dict[id])
  }
  return result
})

const filter = (state: AppGlobalState) => state.mailingList.filter
const sorting = (state: AppGlobalState) => state.mailingList.sorting
const page = (state: AppGlobalState) => state.mailingList.page
const total = (state: AppGlobalState) => state.mailingList.total
const updateProgress = (state: AppGlobalState) => state.mailingList.updateProgress
const removeProgress = (state: AppGlobalState) => state.mailingList.removeProgress
const addProgress = (state: AppGlobalState) => state.mailingList.addProgress
const hasNext = (state: AppGlobalState) => state.mailingList.total > state.mailingList.ids.length
const pageSize = (state: AppGlobalState) => state.mailingList.pageSize
const pages = (state: AppGlobalState) => Math.ceil(state.mailingList.total / state.mailingList.pageSize)

const MailingListSelectors = {
  filter,
  sorting,
  page,
  total,
  updateProgress,
  removeProgress,
  addProgress,
  item,
  meta,
  itemFetchProgress,
  listFetchProgress,
  listFetchError,
  list,
  dict,
  ids,
  hasNext,
  pageSize,
  listFetchNextProgress,
  listFetchNextError,
  pages,
}

export default MailingListSelectors
